module.exports = __webpack_public_path__ + "static/media/jg.6ce36a05.png";